export default (url: string): boolean => url.startsWith('/')
